/* --------------------------------------------------------------------------------------------------------------- */
// Property Favourites
/* --------------------------------------------------------------------------------------------------------------- */


/*
var sh_favourite_properties = (function(){
	
	var fav_props_live = false;
	
	return function display_live()
	{
		alert(fav_props_live);
	}
	
})();
*/

/*
	Handles setting up object to track favourite properties.
	Requires jQuery, jquery.cookie.
*/
Sherlock_favourite_properties = {
	is_active: false
	,
	fav_tools_list: {}
	,
	init: function()
	{
		// Limit visibility to certain pages.
		if( !jQuery('body').hasClass('properties') )
		{
			return(false);
		}
			
		// Setup side tab nav.
		// Do we want the JS to set up the navigation? ...
		//if( jQuery('#side-tab-nav').size() == 0 )
		//{
		//	jQuery('body').append('<div id="side-tab-nav"><ul></ul></div>');
		//}
		//jQuery('#side-tab-nav ul').append('<li class="favourite-properties"><a href="/favourite-properties/">Favourites</a></li>');
		//jQuery('#side-tab-nav ul').append('<li class="clear-favourite-properties"><a href="javascript:;">Clear Favourites</a></li>');
		
		// ... OR rely on third party location.
		jQuery('#side-nav-right').append('<ul class="favourites" />');
		jQuery('#side-nav-right .favourites').append('<li class="favourite-properties"><a href="/favourite-properties/">Favourites</a></li>');
		jQuery('#side-nav-right .favourites').append('<li class="clear-favourite-properties"><a href="javascript:;">Clear Favourites</a></li>');
		
		jQuery('#side-tab-nav .clear-favourite-properties, #side-nav-right .clear-favourite-properties').click(function(){
			Sherlock_favourite_properties.remove_all();
		});
		
		// Store favourites tools.
		Sherlock_favourite_properties.fav_tools_list = jQuery('.favourite');
		
		// Check if any property favourites remain active.
		Sherlock_favourite_properties.check_active();
		
		// Setup UI.
		// Run through favourite tools in the property list. 
		Sherlock_favourite_properties.fav_tools_list.each(function() {
			// Set favourite tool functionality.
			jQuery(this).click(function() {
				if( jQuery(this).hasClass('active') )
				{
					Sherlock_favourite_properties.remove_property( jQuery(this) );
				}
				else
				{
					Sherlock_favourite_properties.add_property( jQuery(this) );
				}
			});
		});
	}
	,
	add_property: function(pm_fav_tool)
	{
		// Get property ID.
		var id = pm_fav_tool.attr('data-prop-id');
		
		// Add cookie.
		jQuery.cookie('sh_property_' + id, id, { path: '/' });
		
		// Check for active list of property favourites.
		Sherlock_favourite_properties.check_active();
	}
	,
	remove_property: function(pm_fav_tool)
	{
		// Get property ID.
		var id = pm_fav_tool.attr('data-prop-id');
		
		// Remove cookie.
		jQuery.removeCookie('sh_property_' + id, { path: '/' });
		
		// Check for active list of property favourites.
		Sherlock_favourite_properties.check_active();
	}
	,
	check_active: function()
	{
		// Get current fav prop list via cookies.
		var fav_prop_list = Sherlock_favourite_properties.get_fav_prop_list();
		
		// Run through favourite tools in the property list.
		Sherlock_favourite_properties.fav_tools_list.each(function() {
			var id = jQuery(this).attr('data-prop-id');
			var cookie_id = 'sh_property_' + id;
			var check_cookie = jQuery.cookie(cookie_id);
			
			// Check if each property is an active favourite via set cookies.
			if( check_cookie )
			{
				// Set class on tool for UI presentation and toggle tracking.
				jQuery(this).addClass('active');
			}
			else
			{  
				// Set class on tool for UI presentation and toggle tracking.
				jQuery(this).removeClass('active');
			}
		});
		
		// Check if property favourites are active.
		var is_active = ( fav_prop_list.length > 0 );
		
		// Set UI.
		if( is_active )
		{
			jQuery('#side-tab-nav .favourite-properties, #side-nav-right .favourite-properties').show();
			jQuery('#side-tab-nav .clear-favourite-properties, #side-nav-right .clear-favourite-properties').show();
			var top = (jQuery('#side-tab-nav').outerWidth(true) + 200 ) + 'px';
			jQuery('#side-tab-nav').css('top',top);
		}
		else
		{
			jQuery('#side-tab-nav .favourite-properties, #side-nav-right .favourite-properties').hide();
			jQuery('#side-tab-nav .clear-favourite-properties, #side-nav-right .clear-favourite-properties').hide();
		}
		
		// Track active state.
		Sherlock_favourite_properties.is_active = is_active;
		
		// Return active state.
		return( is_active );
	}
	,
	remove_all: function()
	{
		// Get copy of present cookie list.
		var id_list = Sherlock_favourite_properties.get_fav_prop_list();
		
		// Delete all cookies.
		for( var i = 0; i < id_list.length; i++ )
		{
			// Remove cookie.
			jQuery.removeCookie(id_list[i], { path: '/' });
		}
		
		// Reset UI.
		Sherlock_favourite_properties.check_active();
	}
	,
	get_fav_prop_list: function()
	{
		var cookie_list = [];
		
		var cookies = jQuery.cookie();
		for(var cookie in cookies)
		{
			if( cookie.indexOf('sh_property_') > -1 )
			{
				cookie_list.push(cookie);
			}
		}
		
		return(cookie_list);
	}
}; // end Sherlock_favourite_properties


jQuery(document).ready(function(jQuery){
	
	Sherlock_favourite_properties.init();
	
});

/* --------------------------------------------------------------------------------------------------------------- */
// end Property Favourites
/* --------------------------------------------------------------------------------------------------------------- */
